import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { FiBriefcase, FiMapPin, FiCalendar } from "react-icons/fi";
import { experiences } from "../data/experience";
import "./Experience.css";

const Experience = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.05 });

  return (
    <section id="experience" className="experience section" ref={ref}>
      <div className="container">
        <motion.div
          className="section__header"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
        >
          <span className="section__label">Experience</span>
          <h2 className="section__title">Professional Journey</h2>
        </motion.div>

        <div className="timeline">
          {experiences.map((exp, i) => (
            <motion.div
              key={exp.id}
              className={`timeline__item ${
                i % 2 === 0 ? "timeline__item--left" : "timeline__item--right"
              }`}
              initial={{ opacity: 0, x: i % 2 === 0 ? -30 : 30 }}
              animate={inView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.5, delay: i * 0.2 }}
            >
              <div className="timeline__dot">
                <FiBriefcase size={14} />
              </div>
              <div className="timeline__card">
                <div className="timeline__card-header">
                  <h3 className="timeline__role">{exp.role}</h3>
                  <h4 className="timeline__company">{exp.company}</h4>
                  <div className="timeline__meta">
                    <span>
                      <FiMapPin size={13} /> {exp.location}
                    </span>
                    <span>
                      <FiCalendar size={13} /> {exp.startDate} — {exp.endDate}
                    </span>
                  </div>
                </div>
                <ul className="timeline__achievements">
                  {exp.achievements.map((item, j) => (
                    <li key={j}>{item}</li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
